<h1 class="participants-title">
  {{ 'raci.participantsSection.title' | translate }}
</h1>

<p class="sections-title">
  {{ 'raci.participantsSection.searchTitle' | translate }}
</p>

<div class="raci-participants">
  <svg-icon src='./assets/icons/search-outline.svg' class="menu-action-icon svg-icon-gray"
            title="{{'projectToolbar.search' | translate | uppercase}}"
            align='center'></svg-icon>
  <input class="participants-search-input" type="text" placeholder="Type the name of the user" [(ngModel)]="searchTerm" (keyup)="searchUsers()" />
</div>
<div *ngIf="showNoParticipantsInfoMessage">
  <h4>{{'raci.participantsAssignment.noParticipantsInfoMessage' | translate}}</h4>
</div>
<div class="section-participants">
  <div *ngFor="let sector of filteredParticipantsByRole">
    <div class="chevron-down-raci-collapse">
          <svg-icon src='./assets/icons/chevron-down-solid.svg'
                    [ngClass]="sector.shouldCollapse ? 'icon-toogle-rotate' : 'icon-toogle' "
                    (click)="expandCollapseSector(!sector?.shouldCollapse, sector?.key)">
          </svg-icon>
          <p class="sections-title">
            {{sector.key}}
          </p>
        </div>
      <div *ngIf="!sector.shouldCollapse">
        <kendo-grid class="kendo-white-grid raci-participants-grid"
                    [data]="sector.value"
                    id="{{sector.key}}"
                    #raciUsersGrid
                    (drop)="onDrop($event)"
                    (dragover)="onDragOver($event, raciUsersGrid)"
                    (dragstart)="onDragStart($event, raciUsersGrid)" [hideHeader]="true">
          <kendo-grid-column [headerClass]="'participants-grid raci-participants-grid'" field="name" title="{{sector.key}}" [width]="40"></kendo-grid-column>
        </kendo-grid>
      </div>
  </div>
</div>
